export const PERMIS_LESSONS_AR = [
  {
    id: 'permis-1',
    numero: 1,
    titre: "الإجراءات الإدارية لرخصة القيادة",
    sousTitre: "ANTS — كل شيء عبر الإنترنت",
    contexte: "رخصة القيادة، تجديدها، الإبلاغ عن فقدانها — كل هذا يتم الآن عبر الإنترنت على ANTS.",
    explication: [
      "**ANTS** (الوكالة الوطنية لوثائق السفر والهوية): permisdeconduire.ants.gouv.fr — الموقع الرسمي لجميع إجراءات الرخصة.",
      "**إنشاء حسابك على ANTS**: برقم وثيقة هويتك. سترسل طلباتك ومتابعتها من هنا.",
      "**في حالة الفقدان أو السرقة**: تقدّم بطلب رخصة بديلة على ANTS مباشرة — 25 أورو. لا حاجة للتنقل.",
      "**انتهاء الصلاحية**: رخصة القيادة الأوروبية صالحة 15 سنة للسائقين دون 60 سنة. تُجدَّد على ANTS.",
      "**التوكيل الإلكتروني**: إذا لم تتمكن من استخدام الإنترنت، يمكن لشخص موثوق التقدم نيابة عنك عبر ANTS.",
    ],
    question: "أين تُقدّم طلب رخصة قيادة بديلة في حالة الفقدان؟",
    options: [
      { id: 'a', text: "على permisdeconduire.ants.gouv.fr", correct: true },
      { id: 'b', text: "في مخفر الشرطة", correct: false },
      { id: 'c', text: "في مكتب البريد", correct: false },
    ],
    explication_reponse: "جميع إجراءات رخصة القيادة تتم الآن على ANTS. لا حاجة للتنقل. الطلب يُعالَج في 2-3 أسابيع.",
  },
  {
    id: 'permis-2',
    numero: 2,
    titre: "نقاط الرخصة وخسارتها",
    sousTitre: "فهم نظام النقاط",
    contexte: "رخصة القيادة الفرنسية تعمل بنظام النقاط. كيف يعمل وكيف تسترد نقاطك؟",
    explication: [
      "**12 نقطة في البداية**: كل سائق يبدأ بـ 12 نقطة (6 للمبتدئين). تُخصم النقاط عند المخالفات.",
      "**استرداد النقاط**: بعد سنتين دون مخالفة، تسترد نقطتين تلقائياً. بعد 3 سنوات نظيفة، ترجع النقاط كاملةً.",
      "**تدريب اختياري**: يمكنك حضور يوم تحسيس (journée de sensibilisation) لاسترداد 4 نقاط — مرة كل 2 سنة.",
      "**التحقق من نقاطك**: على telepoints.ants.gouv.fr أو بطلب وثيقة relève d'information على ANTS.",
      "**الرخصة الصفرية**: إذا وصلت النقاط إلى صفر، تُسحب الرخصة. يجب إعادة الامتحان بعد 6 أشهر.",
    ],
    question: "كيف تسترد نقاطاً في رخصة القيادة دون انتظار؟",
    options: [
      { id: 'a', text: "بحضور يوم تحسيس مرخّص لاسترداد 4 نقاط", correct: true },
      { id: 'b', text: "بدفع غرامة خاصة لإدارة المرور", correct: false },
      { id: 'c', text: "لا يمكن استرداد النقاط قبل 5 سنوات", correct: false },
    ],
    explication_reponse: "يوم التحسيس (stage de récupération de points) يكلف حوالي 250 أورو ويسترد لك 4 نقاط. يمكن تكراره كل سنتين.",
  },
  {
    id: 'permis-3',
    numero: 3,
    titre: "تحويل رخصة قيادة أجنبية",
    sousTitre: "للقادمين من خارج فرنسا",
    contexte: "وصلت إلى فرنسا برخصة قيادة أجنبية. هل يمكنك القيادة؟ كيف تحوّلها؟",
    explication: [
      "**رخص الاتحاد الأوروبي**: صالحة مباشرة في فرنسا — لا حاجة للتحويل. تُجدَّد عند انتهائها على ANTS.",
      "**رخص الدول المعاهِدة**: المغرب، الجزائر، تونس وغيرها — يمكن تحويلها مباشرة بدون إعادة امتحان.",
      "**مدة الإقامة الأولى**: لديك سنة من الحصول على إقامتك لتحويل رخصتك الأجنبية.",
      "**طلب التحويل**: على ANTS مع الوثائق التالية: رخصة أصلية + ترجمة معتمدة، وثيقة إقامة، صورة شمسية.",
      "**الرخص غير المعاهِدة**: إذا كانت بلدك غير معاهِدة، يجب اجتياز امتحان القيادة الفرنسي كاملاً.",
    ],
    question: "هل يمكن تحويل الرخصة المغربية في فرنسا بدون إعادة الامتحان؟",
    options: [
      { id: 'a', text: "نعم، المغرب دولة معاهِدة مع فرنسا", correct: true },
      { id: 'b', text: "لا، يجب اجتياز الامتحان الفرنسي كاملاً", correct: false },
      { id: 'c', text: "نعم لكن فقط بعد 5 سنوات إقامة", correct: false },
    ],
    explication_reponse: "المغرب، الجزائر، تونس وعدة دول عربية أخرى لديها اتفاقيات مع فرنسا تتيح تحويل الرخصة مباشرة. تحقق من قائمة الدول المعاهِدة على ANTS.",
  },
  {
    id: 'permis-4',
    numero: 4,
    titre: "الرخصة الاحترافية والخاصة",
    sousTitre: "أنواع الرخص في فرنسا",
    contexte: "هل تحتاج رخصة خاصة لعملك؟ ما الفرق بين الأنواع المختلفة؟",
    explication: [
      "**رخصة B**: الرخصة العادية للسيارات — ما يعرفه معظم الناس.",
      "**رخصة BE**: لقيادة السيارة مع مقطورة ثقيلة. إضافة على رخصة B.",
      "**رخصة C وCE**: للشاحنات الثقيلة. ضرورية لمهنة السائق المهني.",
      "**رخصة D**: لحافلات نقل الركاب. ضرورية للسائق المهني.",
      "**تمويل الرخصة بـ CPF**: يمكن استخدام رصيد CPF لتمويل رخصة B أو أي رخصة مهنية — فرصة ممتازة.",
    ],
    question: "ما الرخصة اللازمة لقيادة شاحنة ثقيلة مهنياً؟",
    options: [
      { id: 'a', text: "رخصة C أو CE", correct: true },
      { id: 'b', text: "رخصة B مع تصريح خاص", correct: false },
      { id: 'c', text: "رخصة D", correct: false },
    ],
    explication_reponse: "رخصة C للشاحنات الثقيلة بدون مقطورة، CE مع مقطورة. رخصة D هي لحافلات الركاب. يمكن تمويل هذه الرخص المهنية عبر CPF.",
  },
];
